export const routes = [
  {
    route: "home",
    naming: "Inicio",
  },
  {
    route: "requirements",
    naming: "Requisitos",
  },
  {
    route: "benefits",
    naming: "Beneficios",
  },
  {
    route: "faq",
    naming: "FAQ",
  },
];
